module.exports = __webpack_public_path__ + "img/reference-grillshop.62227565.jpg";